import { render, staticRenderFns } from "./GeneralSalesScreen.vue?vue&type=template&id=2869914b&scoped=true"
import script from "./GeneralSalesScreen.vue?vue&type=script&lang=js"
export * from "./GeneralSalesScreen.vue?vue&type=script&lang=js"
import style0 from "./GeneralSalesScreen.vue?vue&type=style&index=0&id=2869914b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2869914b",
  null
  
)

export default component.exports